import Script from 'next/script';

function BeamProductDetailWidget() {
  return (
    <div>
      <Script
        type="module"
        dangerouslySetInnerHTML={{
          __html: `
          import { init } from "https://sdk.beamimpact.com/web-sdk/v1.39.2/dist/integrations/beam.js";

          const beam = await init({
            domain: "briogeohair.com",
            apiKey:"1FZ6VRy197TU.0e43c50d-caa7-4d36-a559-6a893b37fba6",
            chainId:"270",
            storeId:"439",
            baseUrl:"https://production-central-backend-ne.beamimpact.com",
          });`,
        }}
      />
      <Script
        crossorigin=""
        async
        data-em-disable
        src="https://production-beam-widgets.beamimpact.com/web-sdk/v1.39.2/dist/components/product-details-page.esm.js"
        type="module"
      />
      <div className="beam-product-details-widget-container">
        <div className="beam-sync-visibility" data-beam-widget="product-details-page">
          <beam-product-details-page
            apiKey="1FZ6VRy197TU.0e43c50d-caa7-4d36-a559-6a893b37fba6"
            chainId="270"
            storeId="439"
            baseUrl="https://production-central-backend-ne.beamimpact.com"
          ></beam-product-details-page>
        </div>
      </div>
      <style>
        {`.beam-product-details-widget-container {
            display: block;
            text-align: center !important;
            border: 1px solid #DFDFDF;
            padding-left: 15px;
            padding-bottom: 10px;
          }

          @media screen and (max-width: 768px) {
            .beam-product-details-widget-container {
              margin-top: 25px;
              margin-bottom: -20px;
            }
          }`}
      </style>
    </div>
  );
}

export default BeamProductDetailWidget;